/* eslint-disable */
<template>
  <div class="manage-specialist">
    <AdminNavigation ref="navigation" indexProps="3" />
    <div class="top-panel">
      <Header />
      <div v-if="specialist != undefined" class="header-title-section">
        <div class="header-title"><h1>{{ specialist.id != "" ? "Edit Specialist" : "Create New Specialist" }}</h1></div>
        <div class="header-sub-title">{{ specialist.id != "" ? "Enter specialist details and complete their profile to help promote them to the clients." : "Enter new specialist details and complete their profile to help promote them to the clients." }}</div>
      </div>
    </div>
    <div class="panel">
      <AdminSpecialistMenu indexProps="0" />
      <div class="content d-flex">
        <div class="col-9" v-if="specialist != undefined">
          <div class="box">
            <div class="box-heading d-flex align-items-center justify-content-between">
              <span>Specialist Details</span>
              <div class="d-flex">
                <img v-if="specialist.id != ''" class="is-icon"
                  src="@/assets/images/file_icon_circle.svg"
                  data-placement="right"
                  data-toggle="tooltip"
                  title="Download PDF"
                  @click="downloadPdf()"
                />
                <a class="ml-5" @click.stop="" :href="specialist.ZohoLink" target="_blank"><img src="@/assets/images/zoho_icon.svg"
                                                                                  data-placement="right" data-toggle="tooltip"
                                                                                  title="Link to Zoho"/></a>
              </div>
            </div>
            <vue-html2pdf
                v-if="specialist.id"
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="1400"
                filename="SpecialistProfile"
                :pdf-quality="3"
                :manual-pagination="true"
                pdf-format="a4"
                pdf-orientation="portrait"
                ref="html2Pdf"
                @hasDownloaded="hasDownloaded">
              <section slot="pdf-content">
                <PDFProfile :availabilityStr="availabilities" ref="pdfProfile" :x="specialist" />
              </section>
            </vue-html2pdf>
            <div class="box-body">
              <div v-if="specialist.id != ''" class="box-row">
                <div class="box-col box-col-left">Active</div>
                <div class="box-col box-col-right">
                  <toggle-button
                    :value="specialist.specialistStatus"
                    :sync="true"
                    @change="changeStatus"
                    :color="{ checked: '#56C568', unchecked: '#525252' }"
                    :width="40"
                  />
                </div>
              </div>

              <div class="box-row">
                <div class="box-col box-col-left">Name</div>
                <div class="box-col box-col-right">
                  <div
                    class="parent w-100 h-100"
                    @click="openManageSpecialistNameModal">
                    <span v-if="specialist.fullName != ''">{{
                      specialist.fullName
                    }}</span>
                    <input
                      v-else
                      type="text"
                      disabled
                      class="child w-100"
                      :class="hasError && !validateFullName ? 'is-invalid' : ''"
                      placeholder="Click here to add new name" />
                    <div
                      v-if="hasError && !validateFullName"
                      class="text-danger">
                      {{ fullNameError }}
                    </div>
                  </div>
                  <AdminManageSpecialistNameModal :key="modalKey" ref="manageSpecialistNameModal" />
                </div>
              </div>

              <div class="box-row">
                <div class="box-col box-col-left">Contact Details</div>
                <div class="box-col box-col-right">
                  <div class="parent w-100 h-100" @click="openManageSingleContactModal">
                    <span v-if="specialist.contactDetails !== ''">
                      <span v-if="specialist.phone1 !== ''" class="mr-2"><b>P: </b>{{ specialist.phone1 }}</span>
                      <span v-if="specialist.mobile !== ''" class="mr-2"><b>M: </b>{{ specialist.mobile }}</span>
                      <span v-if="specialist.phone2 !== ''" class="mr-2"><b>W: </b>{{ specialist.phone2 }}</span>
                      <span v-if="specialist.email !== ''" class="mr-2"><b>E: </b>{{ specialist.email }}</span>
                      <span v-if="specialist.NotificationEmailAddress !== ''" class="mr-2"><b>N: </b>{{ specialist.NotificationEmailAddress }}</span>
                    </span>
                    <input v-else type="text" disabled class="child w-100" placeholder="Click here to add new contact" />
                    <div v-if="hasError && !validatePhone" class="text-danger">{{ contactMobileError }}</div>
                    <div v-if="hasError && !validatePhone2" class="text-danger">{{ contactWorkPhoneError }}</div>
                    <div v-if="hasError && !validateEmail" class="text-danger">{{ contactEmailError }}</div>
                    <div v-if="hasError && !validateNotification" class="text-danger">{{ contactNotificationError }}</div>
                  </div>
                  <AdminManageSingleContactModal :key="modalKey" ref="manageSingleContactModal" />
                </div>
              </div>

              <div class="box-row">
                <div class="box-col box-col-left">User login access</div>
                <div class="box-col box-col-right row-item">
                  <input type="checkbox" v-model="specialist.isUser" />
                  <v-btn v-if="specialist.isUser && oldSpecialist.isUser && specialist.id != ''" class="ml-10 col-center-content" style="background-color:#C4C4C4;color:#6686B6F" @click="reSendInvitation()"> Resend Invite</v-btn>
                </div>
              </div>

              <div class="box-row">
                <div class="box-col box-col-left">
                  Appointment By Request Only
                </div>
                <div class="box-col box-col-right">
                  <input type="checkbox" v-model="specialist.byRequestOnly" />
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">
                  Vendor generated invoices
                </div>
                <div class="box-col box-col-right">
                  <input
                    type="checkbox"
                    v-model="specialist.vendorGeneratedInvoices"
                  />
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Xero Code</div>
                <div class="box-col box-col-right">
                  <input
                    type="text"
                    :disabled="user.type == 3 ? true : false"
                    v-model="specialist.xeroCode"
                    placeholder="Xero code"
                  />
                  <div v-if="hasError && !validateXeroCode" class="text-danger">{{ xeroCodeError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Client Alignment</div>
                <div class="box-col box-col-right select-client-alignment">
                  <div
                    class="parent"
                    v-if="!clickClientAlignment"
                    @click="handleClientAlignment">
                    <input
                      class="child"
                      type="text"
                      disabled
                      v-model="specialist.clientAlignment"
                      placeholder="Click to choose the Client alignment"
                    />
                  </div>
                  <select v-else v-model="specialist.clientAlignment">
                    <option hidden value="">Please choose ...</option>
                    <option
                      v-for="(clientAlignment, index) in clientAlignments"
                      :value="clientAlignment.value"
                    >
                      {{ clientAlignment.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Practice Location</div>
                <div class="box-col box-col-right d-flex flex-column justify-content-center">
                  <div class="d-flex justify-content-between align-items-center">
                    <el-select :popper-append-to-body="false" placeholder="Please select a primary practice location" filterable v-model="specialist.practiceLocationId" class="w-50" :class="hasError && !validatePracticeLocation ? 'is-invalid' : ''" @change="changePracticeLocation">
                      <el-option v-for="location in locations" :key="location.id" :value="location.id" :label="location.fullLocation">{{ location.fullLocation }}</el-option>
                    </el-select>
                    <router-link v-if="user.type >= 6" :to="{ name: 'admin-manage-location' }"><v-btn class="add-icon" dark>Add New</v-btn></router-link>
                  </div>
                  <div v-if="hasError && !validatePracticeLocation" class="text-danger">{{ practiceLocationSelectError }}</div>
                </div>
              </div>
              <!-- <div class="box-row border-top-0" v-if="Number(specialist.practiceLocationId) > 0">
                <div class="box-col box-col-left"></div>
                <div class="box-col box-col-right">
                  <div v-if="specialist.locations[1] != undefined && specialist.locations[1].fullLocation != ''" class="w-100 is-icon" v-for="(location, index) in specialist.locations" @click="openManageLocationModal(index)">
                    <span :class="index == 0 ? 'hidden-element' : ''">{{ location.fullLocation }}</span>
                  </div>
                  <div v-else @click="openManageLocationModal(0)">
                    <input type="text" disabled class="w-100" placeholder="Click here to add or edit location" />
                  </div>
                </div>
                <AdminManageLocationModal ref="manageLocationModal" />
              </div> -->
            </div>
          </div>

          <!-- Add new practice location -->
          <div class="practice-location pb-10" v-if="specialist.practiceLocationId == 'new'">
            <div class="box">
              <div class="box-heading"><span>Add new practice location</span></div>
              <div class="box-body">
                <div class="box-row">
                  <div class="box-col box-col-left">Location Name</div>
                  <div class="box-col box-col-right">
                    <input type="text" class="pl-1" :class="hasError && !validateLocationName ? 'is-invalid' : ''" v-model="location.name" placeholder="Location name" />
                    <div v-if="hasError && !validateLocationName" class="text-danger">{{ locationNameError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Phone Number</div>
                  <div class="box-col box-col-right">
                    <input type="text" class="pl-1" v-model="location.phoneNumber" placeholder="Phone Number" />
                    <div v-if="hasError && !validatePhoneNumber" class="text-danger">{{ locationPhoneNumberError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Address Line 1</div>
                  <div class="box-col box-col-right">
                    <input type="text" class="pl-1" v-model="location.address1" placeholder="Address Line 1" />
                    <div v-if="hasError && !validateAddress" class="text-danger">{{ locationAddress1Error }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Address Line 2</div>
                  <div class="box-col box-col-right">
                    <input type="text" class="pl-1" v-model="location.address2" placeholder="Address Line 2" />
                    <div v-if="hasError && !validateAddress2" class="text-danger">{{ locationAddress2Error }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">City</div>
                  <div class="box-col box-col-right">
                    <select v-model="location.cityId" class="textbox w-100" :class="hasError && !validateCity ? 'is-invalid' : ''" @change="changeCity()">
                      <option value="" hidden>Please select ...</option>
                      <option value="new">Add New</option>
                      <option v-for="city in cities" :key="city.id" :value="city.id">{{ setCityName(city) }}</option>
                    </select>
                    <div v-if="hasError && !validateCity" class="text-danger">{{ locationCityError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">State</div>
                  <div class="box-col box-col-right">
                    <select v-model="location.state" class="textbox w-100">
                      <option value="" hidden>Please select ...</option>
                      <option :value="state.value" v-for="state in states">{{ state.text }}</option>
                    </select>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Postcode</div>
                  <div class="box-col box-col-right">
                    <input type="text" class="pl-1" placeholder="Enter postcode" v-model="location.postcode" :class="hasError && !validatePostcode ? 'is-invalid' : ''" />
                    <div v-if="hasError && !validatePostcode" class="text-danger">{{ locationPostcodeError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Country</div>
                  <div class="box-col box-col-right">
                    <span class="pl-1">Australia</span>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Geolocation</div>
                  <div class="box-col box-col-right">
                    <input type="text" v-model="location.latitude" placeholder="Latitude" :class="hasError && !validateLatitude ? 'is-invalid' : ''" />
                    <input type="text" v-model="location.longitude" placeholder="Longitude" :class="hasError && !validateLongitude ? 'is-invalid' : ''" />
                    <div v-if="hasError && (!validateLatitude || !validateLongitude)" class="text-danger">{{ locationGeoError }}</div>
                  </div>
                </div>
              </div>
              <AddCityModal ref="addCityModal" :regions="regions" />
            </div>
<!--
            <div class="alert alert-success hidden-element">
              <a class="close" title="close">×</a>
              <b>Success:</b> New practice location created successfully.
            </div>
            <div class="alert alert-danger hidden-element">
              <a class="close" title="close">×</a>
              <b>Error:</b> {{ errorMessage }}
            </div> -->

            <!-- <div class="right-element">
              <v-btn dark class="mr-5" @click="savePracticeLocation" >Save</v-btn>
              <v-btn dark @click="cancelPracticeLocation">Cancel</v-btn>
            </div> -->
          </div>

          <!-- <div v-if="specialist.id != '' && (user.type == 4 || user.type == 6)" class="icon-group">
            <div class="w-100">
              <router-link
                :to="{
                  name: 'admin-manage-rate-card',
                  query: { id: this.specialist.id },
                }"
              >
                <v-btn class="right-float-element" dark>Manage Rate Card</v-btn>
              </router-link>
            </div>
          </div> -->

          <div class="alert alert-success alert-success-resend hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>

          <div class="box">
            <div class="box-heading"><span>Qualifications</span></div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Speciality:</div>
                <div class="box-col box-col-right">
                  <vue-tags-input
                    ref="qualificationTag"
                    v-model="qualificationTag"
                    :tags="qualificationTags"
                    :add-only-from-autocomplete="true"
                    :autocomplete-items="filteredQualifications"
                    placeholder="Add Qualifications"
                    @tags-changed="updateQualificationTags"
                  />
                  <div v-if="hasError && !validateSpecialty" class="text-danger">{{ specialtyTagError }}</div>

                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">
                  Expert in (Conditions / Assessment Areas):
                </div>
                <div class="box-col box-col-right">
                  <vue-tags-input
                    ref="personConditionTag"
                    v-model="personConditionTag"
                    :tags="personConditionTags"
                    :add-only-from-autocomplete="true"
                    :autocomplete-items="filteredPersonConditions"
                    placeholder="Add Conditions"
                    @tags-changed="updatePersonConditionTags"
                  />
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Special Interests:</div>
                <div class="box-col box-col-right">
                  <vue-tags-input
                    ref="interestTag"
                    v-model="interestTag"
                    :tags="interestTags"
                    :autocomplete-items="filteredInterests"
                    placeholder="Add Interests"
                    :add-only-from-autocomplete="true"
                    @tags-changed="updateInterestTags"
                  />
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="box">
            <div class="box-heading"><span>Education</span></div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">
                  Accreditations / Certifications:
                </div>
                <div class="box-col box-col-right">
                  <vue-tags-input
                    ref="certificationTag"
                    v-model="certificationTag"
                    :tags="certificationTags"
                    :autocomplete-items="filterCertifications"
                    placeholder="Add Certifications"
                    :add-only-from-autocomplete="true"
                    @tags-changed="updateCertificationTags"
                  />
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Qualifications</div>
                <div class="box-col box-col-right">
                  <div class="parent w-100 h-100" @click="openManageEducationModal(0)">
                    <span v-if="specialist.educationList != ''">
                      {{ specialist.educationList }}
                      <div class="is-icon right-float-element">
                        <img
                          src="@/assets/images/education_black_icon.svg"
                          data-toggle="tooltip"
                          data-placement="left"
                          title="View Educations"
                        />
                      </div>
                    </span>
                    <input
                      v-else
                      type="text"
                      disabled
                      class="child w-100"
                      placeholder="Click here to add new education"
                    />
                  </div>
                  <AdminManageEducationModal
                    :key="modalKey"
                    ref="manageEducationModal"
                    :specialistProps="specialist"
                  />
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="box">
            <div class="box-heading"><span>Services Performed</span></div>
            <div class="box-body">
              <div v-for="item in bookingTypes" class="box-row" :key="item.id">
                <div class="box-col box-col-left">{{item.name}}</div>
                <div class="box-col box-col-right">
                  <input type="checkbox" @change="onTick($event, item)" :checked="specialist.PerformedServices && specialist.PerformedServices.find(s => s.BookingTypeID === item.id)" />
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="box">
            <div class="box-heading">
              <div>Notification Settings</div>
            </div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Weekly Schedule</div>
                <div style="width:80%" class="box-col">
                  <toggle-button @change="onSettingsToggleChange(5)" :color="{ checked: '#56C568', unchecked: '#525252' }" :width="40" :sync="true" :value="setting.weeklySchedule" />
                  <span class="ml-5">Your appointment schedule sent to you one week prior</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="box">
            <div class="box-heading">
              <div>Allocated Practice Managers</div>
            </div>
            <div class="box-body">
              <div v-for="item in specialist.PracticeManagers" class="box-row" :key="item.PracticeManagerID">
                <div class="box-col box-col-left">{{item.FirstName + ' ' + item.Surname}}</div>
                <div class="box-col">CC to Practice Manager</div>
                <div style="width:40%" class="box-col" title="All comms to Specialist are also automatically CC to the practice manager">
                  <el-switch active-color="#13ce66"
                             inactive-color="#E0E0E0" :value="!!item.CarbonCopy" @change="changeSwitch($event, item)" />
                </div>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="box-heading"><span>Consent Form</span></div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Consent Form 1</div>
                <div class="box-col box-col-right">
                  <input
                    type="text"
                    v-model="specialist.consentForm1"
                    placeholder="Consent Form 1"
                    maxlength="255"
                  />
                  <div v-if="hasError && !validateForm1" class="text-danger">{{ consentForm1Error }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Consent Form 2</div>
                <div class="box-col box-col-right">
                  <input
                    type="text"
                    v-model="specialist.consentForm2"
                    placeholder="Consent Form 2"
                    maxlength="255"
                  />
                  <div v-if="hasError && !validateForm2" class="text-danger">{{ consentForm2Error }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Consent Form 3</div>
                <div class="box-col box-col-right">
                  <input
                    type="text"
                    v-model="specialist.consentForm3"
                    placeholder="Consent Form 3"
                    maxlength="255"
                  />
                  <div v-if="hasError && !validateForm3" class="text-danger">{{ consentForm3Error }}</div>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="box">
            <div class="box-heading"><span>Profile</span></div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Photo</div>
                <div class="box-col box-col-right">
                  <div class="box-col-photo">
                    <div class="rounded-image profile-image">
                      <div class="profile-image-content" :class="specialist.profileThumbnail != '' ? '' : 'notice-background'">
                        <img :src="specialist.profileThumbnail" />
                      </div>
                      <!-- <div class="profile-image-name long-text"></div> -->
                      <div
                        class="edit-icon"
                        data-placement="right"
                        data-toggle="tooltip"
                        title="Change Photo"
                        @click="chooseProfileImage"></div>
                      <input
                        type="file"
                        name="profile-image"
                        accept="image/png, image/jpeg"
                        @change="changeProfileImage" />
                    </div>
                    <!-- <div class="rounded-image profile-image">
                      <div class="profile-image-content">
                        <img id="input" src="" />
                      </div>
                    </div>
                    <div class="rounded-image profile-image">
                      <div class="profile-image-content">
                        <img id="output" src="" />
                      </div>
                    </div> -->
                  </div>
                  <input
                    type="text"
                    v-model="specialist.photoURL"
                    placeholder="Please paste the AWS URL for a submitted profile image here"
                    @change="changePhotoURL"
                  />
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Web Profile</div>
                <div class="box-col box-col-right">
                  <input
                    type="text"
                    v-model="specialist.profileURL"
                    placeholder="e.g. LinkedIn URL or Website Team Profile"
                  />
                  <div v-if="hasError && !validateWebProfile" class="text-danger">{{ webProfileError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Red Alert</div>
                <div class="box-col box-col-right d-flex align-items-center">
                  <input
                      type="text"
                      v-model="redAlert.Note"
                      placeholder="Red Alert Note"
                  />
                  <el-switch v-show="redAlert.Note" class="ml-5" active-color="#13ce66" v-model="redAlert.ShowRedAlert"
                              inactive-color="#E0E0E0" ></el-switch>
                  <div v-show="redAlert.Note" class="is-icon ml-5" @click="deleteNote">
                    <img src="@/assets/images/delete_icon.svg" />
                  </div>
                  <div v-if="hasError && !validateRedAlert" class="text-danger">{{ redAlertNoteError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Profile</div>
                <div class="box-col box-col-right">
                  <vue-editor
                    v-model="specialist.specialistProfile"
                    :editor-toolbar="customToolbar"
                  />
                  <div v-if="hasError && !validateSpecialistProfile" class="text-danger">{{ specialistProfileError }}</div>
                  <!-- <textarea rows="3" maxlength="1000" v-model="specialist.specialistProfile" /> -->
                </div>
              </div>
            </div>
          </div>

          <div class="alert alert-success hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>

          <div class="right-element submit-specialist">
            <v-btn dark @click="submit">
              {{ !specialist.id ? "Create" : "Update" }}
            </v-btn>
          </div>
        </div>
        <div v-else>This specialist not found.</div>
        <div class="col-3 action-log d-inline-block m-0 p-0" style="vertical-align:top;">
          <div style="display: flex;flex-direction: row;">
            <span style="line-height: 3; padding-left: 20%">Contact Logs</span>
            <select @change="upDateLog($event)" class="ml-3 small-selector">
              <option value="0">Recent</option>
              <option value="1">View All</option>
            </select>
          </div>
          <Timeline :timeline="timelineData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminSpecialistMenu from "@/components/AdminSpecialistMenu"
import Header from "@/components/Header"
import AdminManageSpecialistNameModal from "@/components/AdminManageSpecialistNameModal"
import AdminManageSingleContactModal from "@/components/AdminManageSingleContactModal"
import AdminManageEducationModal from "@/components/AdminManageEducationModal"
import AddCityModal from '@/components/AddCityModal'
import Timeline from '@/components/Timeline'
import PDFProfile from "./pdfTemplate/PDFProfile.vue";

export default {
  name: "AdminManageSpecialist",
  components: {
    PDFProfile,
    AdminNavigation,
    AdminSpecialistMenu,
    Header,
    AdminManageSpecialistNameModal,
    AdminManageSingleContactModal,
    AdminManageEducationModal,
    AddCityModal,
    Timeline
  },
  data() {
    return {
      redAlert: {
        ShowRedAlert: true
      },
      oldRedAlert: {
        ShowRedAlert: true
      },
      timelineData: [],
      hasError: false,
      successMessage: "",
      errorMessage: "Please correct the errors shown above and try again.",
      loaded: false,
      bookingTypes: [],
      specialist: utilities.initSpecialist(),
      oldSpecialist: [],
      location: utilities.initLocation(),
      newLocation: utilities.initLocation(),
      setting: utilities.initSeeting(),
      availabilities: null,
      clickClientAlignment: false,
      settingsChanged: false,

      qualificationTag: "",
      qualificationTags: [],
      qualifications: [],

      certificationTag: "",
      certificationTags: [],
      certifications: [],

      personConditionTag: "",
      personConditionTags: [],
      personConditions: [],
      logParam: {
        pageNum: 1,
        pageSize: 10
      },
      interestTag: "",
      interestTags: [],
      interests: [],

      titles: [],
      clientAlignments: [],
      appointmentLengths: [],
      shortAppointmentLengths: [],
      cities: [],
      regions: [],
      states: [],
      hasChangedCC: false,
      locations: [],

      modalKey: 0,
      travelToKey: 0,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
    }
  },
  watch: {
    specialist: {
      handler(value) {
        if (this.loaded) this.$store.dispatch("setNewObject", value)
      },
      deep: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    validateFullName() {
      if (this.specialist.fullName == '') {
        return false
      }
      return true
    },
    validateEmail() {
      if(this.specialist.isUser && (!this.specialist.email || !utilities.validateEmail(this.specialist.email))) {
        return false
      }
      return true
    },

    validateNotification() {
      if(!utilities.validateEmail(this.specialist.NotificationEmailAddress)) {
        return false
      }
      return true
    },
    validatePhone() {
      if(this.specialist.isUser && (!this.specialist.mobile || !utilities.validatePhone(this.specialist.mobile))) {
        return false
      }
      return true
    },

    validatePhone2() {
      if (!utilities.validatePhone(this.specialist.phone2)) {
        return false
      }
      return true
    },
    validatePracticeLocation() {
      if(this.specialist.practiceLocationId == '' || typeof this.specialist.practiceLocationId == 'string') {
        return false
      }
      return true
    },
    validateLocationName() {
      if(this.location.name == '') {
        return false
      }
      return true
    },
    validateCity() {
      if(this.location.cityId == '') {
        return false
      }
      return true
    },
    validatePhoneNumber() {
      return utilities.validatePhone(this.location.phoneNumber)
    },

    validateXeroCode() {
      return utilities.validateXCode(this.specialist.xeroCode)
    },

    validateAddress() {
      return utilities.validatePhone(this.location.address1)
    },

    validateRedAlert() {
      return utilities.validateRedAlert(this.redAlert.Note)
    },

    validateSpecialistProfile() {
      if(!this.specialist.specialistProfile) return true
      return (/^[A-Za-z0-9!@#$*?%-.+'=:(_)&;<>/,\s"-]+$/).test(this.specialist.specialistProfile) && this.specialist.specialistProfile.indexOf('<script') < 0
    },


    validateAddress2() {
      return utilities.validatePhone(this.location.address2)
    },

    validateForm1() {
      return utilities.validateConsentForm(this.specialist.consentForm1)
    },

    validateForm2() {
      return utilities.validateConsentForm(this.specialist.consentForm2)
    },

    validateForm3() {
      return utilities.validateConsentForm(this.specialist.consentForm3)
    },

    validateWebProfile() {
      return utilities.validateWebUrl(this.specialist.profileURL)
    },

    validateSpecialty() {
      return utilities.validateQualification(this.qualificationTag)
    },
    validatePostcode() {
      var regExp = new RegExp('^[0-9]{4}$')
      if(this.location.postcode !== '' && !regExp.test(this.location.postcode)) {
        return false
      }
      return true
    },
    validateLatitude() {
      var regExp = new RegExp('^-?[0-9]+\.[0-9]+$')
      if (this.location.latitude !== '' && !regExp.test(this.location.latitude)) {
        return false
      }
      return true
    },
    validateLongitude() {
      var regExp = new RegExp('^-?[0-9]+\.[0-9]+$')
      if (this.location.longitude !== '' && !regExp.test(this.location.longitude)) {
        return false
      }
      return true
    },
    fullNameError() {
      if (this.validateFullName) return ''
      return 'Full name is required. Click above to open the name dialog and enter title, first name, and surname.'
    },
    contactMobileError() {
      if (this.validatePhone) return ''
      if (this.specialist.isUser && (!this.specialist.mobile || String(this.specialist.mobile).trim() === '')) {
        return 'Mobile is required when user login access is enabled.'
      }
      return utilities.getValidatePhoneError(this.specialist.mobile) || 'Mobile number format is invalid.'
    },
    contactWorkPhoneError() {
      if (this.validatePhone2) return ''
      return utilities.getValidatePhoneError(this.specialist.phone2) || 'Work phone format is invalid.'
    },
    contactEmailError() {
      if (this.validateEmail) return ''
      if (this.specialist.isUser && (!this.specialist.email || String(this.specialist.email).trim() === '')) {
        return 'Email is required when user login access is enabled.'
      }
      return 'Enter a valid email address.'
    },
    contactNotificationError() {
      if (this.validateNotification) return ''
      if (!this.specialist.NotificationEmailAddress || String(this.specialist.NotificationEmailAddress).trim() === '') {
        return 'Notification email is required.'
      }
      return 'Enter a valid notification email address.'
    },
    xeroCodeError() {
      if (this.validateXeroCode) return ''
      return 'Xero code only allow numbers and letters hyphen, and max 36 characters'
    },
    practiceLocationSelectError() {
      if (this.validatePracticeLocation) return ''
      return 'Select a primary practice location from the list (or add a new location first).'
    },
    locationNameError() {
      if (this.validateLocationName) return ''
      return 'Location name is required.'
    },
    locationPhoneNumberError() {
      if (this.validatePhoneNumber) return ''
      return utilities.getValidatePhoneError(this.location.phoneNumber) || 'Phone number format is invalid.'
    },
    locationAddress1Error() {
      if (this.validateAddress) return ''
      return utilities.getValidatePhoneError(this.location.address1) || 'Address line 1 format is invalid.'
    },
    locationAddress2Error() {
      if (this.validateAddress2) return ''
      return utilities.getValidatePhoneError(this.location.address2) || 'Address line 2 format is invalid.'
    },
    locationCityError() {
      if (this.validateCity) return ''
      return 'Select a city from the list, or choose Add New.'
    },
    locationPostcodeError() {
      if (this.validatePostcode) return ''
      return utilities.getValidatePostCodeError(this.location.postcode) || 'Australian postcode must be exactly 4 digits.'
    },
    locationGeoError() {
      if (this.validateLatitude && this.validateLongitude) return ''
      const la = utilities.getDecimalCoordinateError(this.location.latitude, 'Latitude')
      const lo = utilities.getDecimalCoordinateError(this.location.longitude, 'Longitude')
      return [la, lo].filter(Boolean).join(' ')
    },
    consentForm1Error() {
      if (this.validateForm1) return ''
      return utilities.getConsentFormError(this.specialist.consentForm1) || 'Consent form 1 value is invalid.'
    },
    consentForm2Error() {
      if (this.validateForm2) return ''
      return utilities.getConsentFormError(this.specialist.consentForm2) || 'Consent form 2 value is invalid.'
    },
    consentForm3Error() {
      if (this.validateForm3) return ''
      return utilities.getConsentFormError(this.specialist.consentForm3) || 'Consent form 3 value is invalid.'
    },
    webProfileError() {
      if (this.validateWebProfile) return ''
      return utilities.getWebUrlError(this.specialist.profileURL) || 'Web profile URL format is invalid.'
    },
    redAlertNoteError() {
      if (this.validateRedAlert) return ''
      return utilities.getRedAlertError(this.redAlert.Note) || 'Red Alert note format is invalid.'
    },
    specialistProfileError() {
      if (this.validateSpecialistProfile) return ''
      const p = this.specialist.specialistProfile
      if (!p) return ''
      if (p.toLowerCase().indexOf('<script') >= 0) {
        return 'Profile content cannot contain script tags.'
      }
      return 'Use only letters, numbers, spaces, and these characters: . : _,\'=()+/"-&!@#$*?%'
    },
    specialtyTagError() {
      if (this.validateSpecialty) return ''
      return utilities.getQualificationError(this.qualificationTag) || 'Speciality text is invalid.'
    },
    filteredQualifications() {
      return this.qualifications.filter((i) => {
        return i.text.toLowerCase().indexOf(this.qualificationTag.toLowerCase()) !== -1
      })
    },
    filteredPersonConditions() {
      return this.personConditions.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1
        )
      })
    },
    filteredInterests() {
      return this.personConditions.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.interestTag.toLowerCase()) !== -1
        )
      })
    },
    filterCertifications() {
      return this.certifications.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.certificationTag.toLowerCase()) !== -1
        )
      })
    },
  },
  methods: {
    hasDownloaded() {
      this.$store.dispatch('loading/setLoadComponent', false)
    },
    changeSwitch(v, item) {
      item.CarbonCopy = v ? 1: 0
      this.hasChangedCC = true
      utilities.changeSpecialistCC({
        SpecialistID: this.specialist.id,
        PracticeManagerID: item.PracticeManagerID,
        CarbonCopy: v ? 1: 0
      })
    },
    upDateLog(e) {
      if (e.target.value === '1') {
        this.logParam.pageSize = 999
      } else {
        this.logParam.pageSize = 10
      }
      this.getLogs()
    },
    deleteNote() {
      this.redAlert = {}
    },
    onTick(v, item) {
      if(v.target.checked) {
        const index = this.specialist.PerformedServices.findIndex(s => s.BookingTypeID === item.id)
        if(index < 0) {
          this.specialist.PerformedServices.push({BookingTypeID: item.id})
        }
      } else {
        const index = this.specialist.PerformedServices.findIndex(s => s.BookingTypeID === item.id)
        if(index > -1) {
          this.specialist.PerformedServices.splice(index, 1)
        }
      }
    },
    updatePersonConditionTags(newTags) {
      // if(this.$refs.personConditionTag.newTag.length == 0) newTags.pop()
      this.personConditionTags = newTags
    },
    updateQualificationTags(newTags) {
      // Commit id 17666983 - When I type in a random item in a listbox, I can hit enter and that is being added i.e. not a real entry. Please prevent that from happening
      // Set "add-only-from-autocomplete = true" to prevent hitting enter free text so don't need the code below
      // if(this.$refs.qualificationTag.newTag.length == 0) newTags.pop()
      this.qualificationTags = newTags
    },
    updateInterestTags(newTags) {
      // if(this.$refs.interestTag.newTag.length == 0) newTags.pop()
      this.interestTags = newTags
    },
    updateCertificationTags(newTags) {
      // if(this.$refs.certificationTag.newTag.length == 0) newTags.pop()
      this.certificationTags = newTags
    },

    changeStatus() {
      this.specialist.specialistStatus = !this.specialist.specialistStatus
    },
    changeAppointment() {
      this.specialist.byRequestOnly = !this.specialist.byRequestOnly
    },
    changeVendor() {
      this.specialist.vendorGeneratedInvoices = !this.specialist
        .vendorGeneratedInvoices
    },

    async reSendInvitation() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      var mobile = utilities.updateMobileCode(utilities.validatePhonenumber(this.specialist.mobile))
      if(mobile.charAt(0) == '0') {
        mobile = mobile.substring(1)
      }
      var params = {
        Name: this.specialist.userName,
        EmailAddress: this.specialist.email,
        Mobile: mobile,
        UserRoleID: 5,
      }
      var result = await utilities.postResendInvite(this.specialist.userId, params)
      if (result) {
        this.successMessage = 'Invitation sent successfully.'
        utilities.showAlert(".alert-success-resend")
      }
      this.$store.dispatch('loading/setLoadComponent', false)

    },

    async downloadPdf() {
      this.$store.dispatch('loading/setLoadComponent', true)
      const StartDate = window.moment().add(1, 'day').format('YYYY-MM-DD')
      const EndDate = window.moment(StartDate).add(2, 'day').format('YYYY-MM-DD')
      this.availabilities = await utilities.getSpAvailabilitiesNext3Days(this.specialist.id)
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
        this.$store.dispatch('loading/setLoadComponent', false)
      }, 1000)

      // this.$store.dispatch('loading/setLoadComponent', true)
      // var pdf = await utilities.getSpecialistProfilesByIds(this.specialist.id)
      // var specialistName = this.specialist.firstName.replace(/ /g, "") + this.specialist.lastName.replace(/ /g, "")
      // var fileName = 'SpecialistProfile' + specialistName + ".pdf"
      // var a = document.createElement('a')
      // let blob = pdf
      // a.setAttribute('href', window.URL.createObjectURL(blob))
      // a.setAttribute('download', fileName)
      // a.click()
      // this.$store.dispatch('loading/setLoadComponent', false)
    },

    chooseProfileImage() {
      $("input[type='file'][name='profile-image']").click()
    },
    setCityName(city) {
      var name = city.name
      if (city.region) {
        name = name + ', ' + city.region.name
      }
      return name
    },
    async changeProfileImage(e) {
      if (!e.target.files.length) {
        return false
      }

      this.specialist.photoURL = ""
      var object = await utilities.convertFileToBase64(e.target.files[0])
      this.specialist.photo = object
      this.specialist.profileThumbnail = object.file.base64
    },
    changePhotoURL() {
      this.specialist.photo = ""
    },
    handleClientAlignment() {
      this.clickClientAlignment = true
    },
    openManageSpecialistNameModal() {
      this.$refs.manageSpecialistNameModal.specialist = this.specialist
      this.$refs.manageSpecialistNameModal.handleModal()
    },
    openManageSingleContactModal() {
      if (!this.specialist.isUser && this.oldSpecialist.isUser) {
        utilities.showWarningMessage("Please update your changes first.")
        return;
      }

      this.$refs.manageSingleContactModal.specialist = _.cloneDeep(this.specialist)
      this.$refs.manageSingleContactModal.handleModal()
    },
    openManageEducationModal(index) {
      this.$store.dispatch("loading/setLoadComponent", true)
      this.$refs.manageEducationModal.handleModal()
      this.$refs.manageEducationModal.specialist = this.specialist
      this.$refs.manageEducationModal.openEducation(index)
      this.$store.dispatch("loading/setLoadComponent", false)
    },
    changePracticeLocation() {
      if (this.specialist.practiceLocationId == "new") {
        this.location = utilities.initLocation()
        if(this.specialist.id) this.location.specialistId = this.specialist.id
        setTimeout(() => {
          $("html").animate({ scrollTop: $(".practice-location").offset().top - 100 }, 'slow')
        }, 200)
      }
    },
    goToRateCard(specialistId) {
      this.$router.push({ name:'admin-manage-rate-card', query: { id: specialistId } })
    },
    changeCity() {
      if (this.location.cityId == 'new') {
        //show popup
        this.$refs.addCityModal.handleModal()
      } else {
        var city = this.cities.find((x) => { return x.id == this.location.cityId })
        if(city != undefined) {
          this.location.cityName = city.name
          this.location.regionId = city.regionId
        }
      }
    },
    onSettingsToggleChange(index) {
      this.settingsChanged = true
      switch (index) {
        case 1:
          this.setting.newBookingNotification = !this.setting.newBookingNotification
          break
        case 2:
          this.setting.bookingChange = !this.setting.bookingChange
          break
        case 3:
          this.setting.availabilityReminder = !this.setting.availabilityReminder
          break
        case 4:
          this.setting.availabilityReturned = !this.setting.availabilityReturned
          break
        case 5:
          this.setting.weeklySchedule = !this.setting.weeklySchedule
          break
        case 6:
          this.setting.scheduleChange = !this.setting.scheduleChange
          break
        case 7:
          this.setting.reportsDue = !this.setting.reportsDue
          break
        case 8:
          this.setting.reportsOverdue = !this.setting.reportsOverdue
          break
        case 9:
          this.setting.bookingReminder = !this.setting.bookingReminder
          break
        default:
      }
    },
    async savePracticeLocation() {
      if (!this.validateLocationName || !this.validateCity || !this.validatePostcode || !this.validateLatitude || !this.validateLongitude || !this.validatePhoneNumber || !this.validateAddress || !this.validateAddress2) {
        this.hasError = true
        utilities.showAlert(".alert-danger")
        return
      } else {
        this.hasError = false
      }

      this.$store.dispatch("loading/setLoadComponent", true)
      var result = await this.postLocation()
      if (result) {
        this.specialist.practiceLocationId = result
        //utilities.showAlert('.practice-location .alert-success')
        this.locations = await utilities.getLocations()
      }
      this.$store.dispatch("loading/setLoadComponent", false)
    },
    async submit(e) {
      console.log(this.qualificationTag)
      e.preventDefault()
      e.stopPropagation()

      if (this.specialist.practiceLocationId == 'new') {
        await this.savePracticeLocation()
      }
      if (!this.validateSpecialistProfile || !this.validateRedAlert || !this.validateWebProfile || !this.validateForm1 || !this.validateForm2 || !this.validateForm3 ||!this.validateSpecialty || !this.validatePhone2 || !this.validateNotification || !this.validateFullName || !this.validateEmail || !this.validatePhone || !this.validatePracticeLocation || !this.validateXeroCode) {
        this.hasError = true
        utilities.showAlert(".alert-danger")
        return false
      } else {
        this.hasError = false
      }

      this.specialist.specialistProfile = this.specialist.specialistProfile.replace(/(<a href=\"[a-zA-Z0-9\:\/\/\.-]*\">)/g, "")
      this.specialist.specialistProfile = this.specialist.specialistProfile.replace(/(<\/a>)/g, "")
      if (!this.specialist.id) {
        this.addSpecialist()
      } else {
        this.editSpecialist()
      }
    },
    async postLocation() {
      var params = {
        LocationName: this.location.name,
        AddressLine1: this.location.address1,
        AddressLine2: this.location.address2,
        CityID: this.location.cityId,
        State: this.location.state,
        Postcode: this.location.postcode,
        PhoneNumber: this.location.phoneNumber,
        UserID: this.user.id,
        Username: this.user.name,
      }

      if (this.location.latitude == '' || this.location.longitude == '') {
        var coordinates = await utilities.getGeoLocation(this.location.name + ', ' + this.location.address1 + ',' + this.location.address2 + ',' + this.location.cityName + ',' + this.location.state)
        params.Latitude = coordinates.lat
        params.Longitude = coordinates.lng
        this.location.latitude = coordinates.lat
        this.location.longitude = coordinates.lng
      } else {
        params.Latitude = this.location.latitude
        params.Longitude = this.location.longitude
      }
      var callback = (response) => {
        setTimeout(() => {
          this.specialist.practiceLocationId = response
          this.location.id = response
          this.newLocation = _.cloneDeep(this.location)
        }, 1000)
      }
      if(this.location.specialistId != '') params.SpecialistID = this.location.specialistId
      return utilities.postLocation(params, callback)
    },
    async putLocation() {
      var params = {
        LocationID: this.newLocation.id,
        LocationName: this.newLocation.name,
        CityID: this.location.cityId,
        SpecialistID: this.specialist.id,
        UserID: this.user.id,
        Username: this.user.name,
      }
      var callback = (response) => {}
      return utilities.putLocation(params, callback)
    },
    async postSpecialist() {
      var locations = []
      var location = {}
      this.specialist.locations.map((x) => {
        if (x.cityId != "") {
          location = {
            LocationID: "",
            LocationName: x.name,
            AddressLine1: x.address1,
            AddressLine2: x.address2,
            CityID: x.cityId,
            State: x.state,
            Postcode: x.postcode,
            Country: x.country,
          }
          locations.push(location)
        }
      })
      var certifications = []

      var personConditions = []

      var interests = []
      var params = {
        Title: this.specialist.title,
        FirstName: this.specialist.firstName,
        Surname: this.specialist.lastName,
        PhoneNumber1: utilities.validatePhonenumber(this.specialist.phone1),
        PhoneNumber2: utilities.validatePhonenumber(this.specialist.phone2),
        Mobile: utilities.updateMobileCode(utilities.validatePhonenumber(this.specialist.mobile)),
        EmailAddress: this.specialist.email,
        NotificationEmailAddress: this.specialist.NotificationEmailAddress,
        ClientAlignment: this.specialist.clientAlignment,
        IsUser: utilities.convertBoolToNum(this.specialist.isUser),
        ByRequestOnly: utilities.convertBoolToNum(
          this.specialist.byRequestOnly
        ),
        VendorGeneratedInvoices: utilities.convertBoolToNum(
          this.specialist.vendorGeneratedInvoices
        ),
        ConsentForm1: this.specialist.consentForm1,
        ConsentForm2: this.specialist.consentForm2,
        ConsentForm3: this.specialist.consentForm3,
        ProfileURL: this.specialist.profileURL,
        SpecialistProfile: this.specialist.specialistProfile,
        SpecialistStatus: utilities.convertBoolToNum(
          this.specialist.specialistStatus
        ),
        XeroCode: this.specialist.xeroCode,
        PracticeLocationID: this.specialist.practiceLocationId,
        Qualifications: this.qualificationTags.map((x) => {return {QualificationID: x.id}}),
        Certifications: certifications,
        PersonConditions: personConditions,
        Interests: interests,
        Educations: this.specialist.educations.map(x => {
          return {
            Education: x.education,
            YearObtained: x.yearObtained.toString()
          }
        }),
        PerformedServices: this.specialist.PerformedServices
      }

      var callback = (response) => {
        this.specialist.id = response
        if(this.redAlert.Note) {
          utilities.postSpAlertNote(response, {Note: this.redAlert.Note, ShowRedAlert: this.redAlert.ShowRedAlert ? 1 : 0})
        }
      }
      return await utilities.postSpecialist(params, callback)
    },

    async putProfilePicture() {
      var params = {
        SpecialistID: this.specialist.id,
        FirstName: this.specialist.firstName,
        Surname: this.specialist.lastName,
        ProfileUpdateOnly: 1
      }

      if (typeof this.specialist.photo != "string") {
        var object = this.specialist.photo
        params.ProfilePicture = object.base64
        params.SpecialistName = utilities.removeSpace(this.specialist.firstName + this.specialist.lastName)
        params.DateUploaded = moment().format("YYYY-MM-DD HH:mm:ss").replace(" ", "_")
        params.ImageType = object.type

        var resizeImage = await utilities.resizeImage(object.file)
        params.ProfileThumbnail = resizeImage
      } else if (this.specialist.photoURL != "") {
        params.Photo = this.specialist.photoURL
      }

      var callback = (response) => {}
      return utilities.putSpecialist(params, callback)
    },

    async getLogs() {
      this.timelineData = []
      const logs = await utilities.getSpecialisttLogs(this.logParam)
      logs.map((x) => {
        let timeline = {
          id: x.ClientContactLogID,
          userName: decodeURIComponent(x.Username),
          datetime: utilities.formatDate(x.LogDate, 'DD/MM/YYYY hh:mm A', "YYYY-MM-DD HH:mm:ss.ssssss"),
          body: decodeURIComponent(x.LogDetails),
        }
        this.timelineData.push(timeline)
      })
    },

    async putSpecialist() {
      let educations = []
      this.specialist.educations.map((x) => {
        if (x.education != "" && x.yearObtained != "") {
          let education = {
            SpecialistEducationID: "",
            Education: x.education,
            YearObtained: x.yearObtained.toString(),
          }
          educations.push(education)
        }
      })

      var zohoId = this.specialist.zohoLink.split("/")
      zohoId = zohoId[zohoId.length - 1]
      var params = {
        SpecialistID: this.specialist.id,
        Title: this.specialist.title,
        FirstName: this.specialist.firstName,
        Surname: this.specialist.lastName,
        PhoneNumber1: utilities.validatePhonenumber(this.specialist.phone1),
        PhoneNumber2: utilities.validatePhonenumber(this.specialist.phone2),
        Mobile: utilities.updateMobileCode(utilities.validatePhonenumber(this.specialist.mobile)),
        EmailAddress: this.specialist.email,
        NotificationEmailAddress: this.specialist.NotificationEmailAddress,
        ClientAlignment: this.specialist.clientAlignment,
        IsUser: utilities.convertBoolToNum(this.specialist.isUser),
        ByRequestOnly: utilities.convertBoolToNum(
          this.specialist.byRequestOnly
        ),
        VendorGeneratedInvoices: utilities.convertBoolToNum(
          this.specialist.vendorGeneratedInvoices
        ),
        ConsentForm1: this.specialist.consentForm1,
        ConsentForm2: this.specialist.consentForm2,
        ConsentForm3: this.specialist.consentForm3,
        ProfileURL: this.specialist.profileURL,
        SpecialistProfile: this.specialist.specialistProfile,
        SpecialistStatus: utilities.convertBoolToNum(this.specialist.specialistStatus),
        XeroCode: this.specialist.xeroCode,
        SpecialistSetting: {
          WeeklySchedule: this.setting.weeklySchedule
        },
        PracticeLocationID: this.specialist.practiceLocationId,
        Qualifications: this.qualificationTags.map(item => {
          return {
            QualificationID: item.id
          }
        }),
        Certifications: this.certificationTags.map(x => {
          return {
            CertificationID: x.id
          }
        }),
        PersonConditions: this.personConditionTags.map(x => {
          return {
            PersonConditionID: x.value
          }
        }),
        Interests: this.interestTags.map(x => {
          return {
            PersonConditionID: x.value
          }
        }),
        Educations: this.specialist.educations.map(x => {
          return {
            Education: x.education,
            YearObtained: x.education ? x.yearObtained.toString() : ""
          }
        }),
        ZohoLink: zohoId,
        ProfileUpdateOnly: 0,
        PerformedServices: this.specialist.PerformedServices.map(item => {
          return {
            BookingTypeID: item.BookingTypeID
          }
        })
      }

      if (typeof this.specialist.photo != "string") {
        var object = this.specialist.photo
        params.ProfilePicture = object.base64
        params.SpecialistName = utilities.removeSpace(this.specialist.firstName + this.specialist.lastName)
        params.DateUploaded = window.moment().format("YYYY-MM-DD HH:mm:ss").replace(" ", "_")
        params.ImageType = object.type

        var resizeImage = await utilities.resizeImage(object.file)
        params.ProfileThumbnail = resizeImage
      } else if (this.specialist.photoURL != "") {
        params.Photo = this.specialist.photoURL
      }

      if((this.redAlert.Note !== this.oldRedAlert.Note || this.redAlert.ShowRedAlert !== !!this.oldRedAlert.ShowRedAlert) && this.oldRedAlert.Note && this.redAlert.Note) {
        utilities.putSpAlertNote(this.specialist.id, {Note: this.redAlert.Note, ShowRedAlert: this.redAlert.ShowRedAlert ? 1 : 0})
      } else if (!this.oldRedAlert.Note && this.redAlert.Note) {
        utilities.postSpAlertNote(this.specialist.id, {Note: this.redAlert.Note, ShowRedAlert: this.redAlert.ShowRedAlert ? 1 : 0})
      } else if (this.oldRedAlert.Note && !this.redAlert.Note) {
        utilities.deleteSpAlertNote(this.specialist.id)
      }

      var callback = (response) => {

      }
      return utilities.putSpecialist(params, callback)
    },

    async addSpecialist() {
      this.$store.dispatch("loading/setLoadComponent", true)
      try {
        var result = await this.postSpecialist()
        if (result) {
          // Clear changing object
          utilities.clearChangingObject()
          if (this.specialist.isUser) {
            this.successMessage = "Specialist created and invited to Red Health Online successfully."
          } else {
            this.successMessage = "Specialist created successfully."
          }
          utilities.showAlert(".alert-success")
          setTimeout(async () => {
            this.$router.push({ name:'admin-manage-specialist', query: { id: this.specialist.id } })
          }, 2000)
        }
        this.$store.dispatch("loading/setLoadComponent", false)
      } catch (e) {
        this.$store.dispatch("loading/setLoadComponent", false)
      }

    },
    async editSpecialist() {
      this.$store.dispatch("loading/setLoadComponent", true)
      var result2 = await this.putSpecialist()
      if (result2) {
        // Clear changing object
        utilities.clearChangingObject()
        this.loaded = false
        this.successMessage = "Specialist updated successfully."
        utilities.showAlert(".alert-success")
        await this.loadSpecialist()
      }
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    async getSpecialistInfo() {
      var specialistId = this.$route.query != undefined && this.$route.query.id != undefined ? this.$route.query.id : ""
      if (specialistId != "") {
        this.specialist = await utilities.getSpecialistById(specialistId)
        if (this.specialist.specialistMinimumAppiontmentTime.length > 0) {
          this.specialist.minimumAppointment = this.specialist.specialistMinimumAppiontmentTime[0]
        }
      }
    },

    async loadData() {
      if (this.specialist != undefined) {
        // Ticket #5425 - to improve the page speed, call getBulkRefData API to get comman objects.
        const arr = [utilities.getLocations(), utilities.getBookingTypes(), utilities.getQualifications(), utilities.getCertificationsChoice(), utilities.getPersonConditions()]
        if(this.user.type >= 6) {
          arr.push(utilities.getRegions())
          arr.push(utilities.getCities())
        }
        const result = await Promise.all(arr)
        this.bookingTypes = result[1]

        this.locations = result[0] //await utilities.getLocations()

        var qualifications = result[2] //await utilities.getQualifications()
        this.qualifications = utilities.getAutoCompleteTags(qualifications)

        var certifications = result[3] //await utilities.getCertifications()
        this.certifications = utilities.getAutoCompleteTags(certifications)

        var personConditions = result[4] //await utilities.getPersonConditions()
        this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)

        this.interests = utilities.getAutoCompleteTags(personConditions)
        this.titles = utilities.getTitles()
        this.clientAlignments = utilities.getClientAlignments()
        this.shortAppointmentLengths = utilities.getShortAppointmentLengths()
        this.appointmentLengths = [...this.shortAppointmentLengths.slice(0, this.shortAppointmentLengths.length - 1) , ...utilities.getAppointmentLengths(), ...utilities.getLongAppointmentLengths()]

        if(this.user.type >= 6) {
          this.regions = result[5] //await utilities.getRegions()
          var cities = result[6] //await utilities.getCities()
          console.log(cities)
          cities.map((x) => {
            x.region = this.regions.find((y) => y.id == x.regionId)
          }).sort((a, b) => {
            return a.cityName > b.cityName ? 1 : -1
          })
          this.cities = cities
        }
        this.states = utilities.getStates()
      }
    },

    async loadSpecialist() {
      var specialistId = this.$route.query != undefined && this.$route.query.id != undefined ? this.$route.query.id : ""
      if (specialistId != "") {
        this.logParam.SpecialistID = specialistId
        await this.getLogs()
        this.specialist = await utilities.getSpecialistById(specialistId)
        this.$store.dispatch("loading/setLoadComponent", false)
        this.oldSpecialist = _.cloneDeep(this.specialist)
        if (this.specialist == undefined) return false

        await this.$store.dispatch("setOriginalObject", this.specialist)
        await this.$store.dispatch("setNewObject", this.specialist)
        //Ticket #5425 - to improve the page speed, get following two api data inside getSpecialistById()
        //this.setting = await utilities.getSpecialistSeetings(this.specialist.id)
        if (this.specialist.specialistMinimumAppiontmentTime.length > 0) {
          this.specialist.minimumAppointment = this.specialist.specialistMinimumAppiontmentTime[0]
        }

        if (this.specialist.specialistSetting) {
          this.setting = this.specialist.specialistSetting
        }

        var qualification = {}
        this.qualificationTags = []
        this.specialist.qualifications.map((x) => {
          if (x.qualificationId != "") {
            qualification = {
              id: x.qualificationId,
              value: x.qualificationId,
              text: x.qualificationName,
            }
            this.qualificationTags.push(qualification)
          }
        })

        var certification = {}
        this.certificationTags = []
        this.specialist.Certifications.map((x) => {
          if (x.id != "") {
            certification = {
              id: x.CertificationID,
              value: x.CertificationID,
              text: x.CertificationName,
            }
            this.certificationTags.push(certification)
          }
        })

        var personCondition = {}
        this.personConditionTags = []
        this.specialist.PersonConditions.map((x) => {
          if (x.id != "") {
            personCondition = {
              id: x.PersonConditionID,
              value: x.PersonConditionID,
              text: decodeURIComponent(x.ConditionName)
            }
            this.personConditionTags.push(personCondition)
          }
        })

        var interest = {}
        this.interestTags = []
        this.specialist.Interests.map((x) => {
          if (x.id != "") {
            interest = {
              id: x.PersonConditionID,
              value: x.PersonConditionID,
              text: decodeURIComponent(x.ConditionName),
            }
            this.interestTags.push(interest)
          }
        })

        console.log(this.specialist.educationList)

        this.oldRedAlert = await utilities.getSpAlertNotes(this.specialist.id)
        this.oldRedAlert.ShowRedAlert = !!this.oldRedAlert.ShowRedAlert
        this.redAlert = _.cloneDeep(this.oldRedAlert)
      }

      if (this.specialist != undefined && this.specialist.minimumAppointment.independentMedicalAssessment == "") this.specialist.minimumAppointment.independentMedicalAssessment = 60
      if (this.specialist != undefined && this.specialist.minimumAppointment.independentMedicalAssessmentVideo == "") this.specialist.minimumAppointment.independentMedicalAssessmentVideo = 60
      if (this.specialist != undefined && this.specialist.minimumAppointment.independentMedicalAssessmentAbuse == "") this.specialist.minimumAppointment.independentMedicalAssessmentAbuse = 60
      if (this.specialist != undefined && this.specialist.minimumAppointment.phoneCall == "") this.specialist.minimumAppointment.phoneCall = 30

      this.modalKey += 1
    },
  },
  async beforeMount() {
    this.$watch(
        () => this.user,
        async (newVal, oldVal) => {
          console.log(newVal)
          if (newVal) {
            await this.$store.dispatch("loading/setLoadComponent", true)
            await this.loadSpecialist()
            await this.loadData()
            this.loaded = true
            await this.$store.dispatch("loading/setLoadComponent", false)
          }
        },
        { immediate: true, deep: true }
    )

  }
}
</script>
